import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { TextField, makeStyles } from "@material-ui/core";
import { selectName, set } from "./nameSlice";
import { selectLanguage } from "../language/languageSlice";
const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    "& > *": {
      margin: theme.spacing(1),
      width: "100%",
      "&:hover": {
        boxShadow: "0 3px 6px rgba(0,0,0,0.16), 0 3px 6px rgba(0,0,0,0.23)",
      },
      transition: "box-shadow 0.75s",
    },
  },
}));

export function Name() {
  const classes = useStyles();
  const nameValue = useSelector(selectName);
  const language = useSelector(selectLanguage);
  const dispatch = useDispatch();
  // const [incrementAmount, setIncrementAmount] = useState("2");

  return (
    <form className={classes.root} noValidate autoComplete="on">
      <TextField
        required
        id="input-fullname"
        label={
          language !== undefined
            ? language === "TH"
              ? "ชื่อ - นามสกุล"
              : "Contact Name"
            : "Contact Name"
        }
        placeholder={
          language !== undefined
            ? language === "TH"
              ? "ชื่อ"
              : "Name"
            : "Name"
        }
        color="secondary"
        fullWidth
        multiline
        rowsMax={5}
        value={nameValue}
        variant="outlined"
        onChange={(e) => {
          if (e.target.value.length <= 200) {
            dispatch(set(e.target.value));
          }
        }}
      />{" "}
    </form>
  );
}
